import ReactDOM from "react-dom/client";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { Joke } from "./pages/joke";
import { Home } from "./pages/home";
import { Header } from "./components/header";
import { Cat } from "./pages/cat";
import { RockPaperScissors } from "./pages/rock-paper-scissors";
import { ContactForm } from "./pages/form";
import { HistoryCat } from "./pages/history_cat";
import { Cookies } from "./components/cookies";
import { LOLCharacters } from "./pages/lol_characters";
import { DetailLolCharacter } from "./pages/detail_lol_character";
import { Error404 } from "./pages/404";
import { ToDoList } from "./pages/to_do_list";

const rootElement = document.getElementById("root");
if (rootElement === null) {
  console.error("missing root in index.html");
} else {
  ReactDOM.createRoot(rootElement).render(
    <Router>
      <Header />
      <Cookies />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/joke" element={<Joke />} />
        <Route path="/cat" element={<Cat />} />
        <Route path="/rock-paper-scissors" element={<RockPaperScissors />} />
        <Route path="/form" element={<ContactForm />} />
        <Route path="/history-cat" element={<HistoryCat />} />
        <Route path="/characters-lol" element={<LOLCharacters />} />
        <Route path="/to_do_list" element={<ToDoList />} />
        <Route path="/characters-lol/:id" element={<DetailLolCharacter />} />
        <Route path="/404" element={<Error404 />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Router>
  );
}
